import { Box, TextField, Typography } from "@mui/material";
import CommentIcon from "@mui/icons-material/Comment";
import React from "react";
import { sizes } from "../setupUtils";
import { useDispatch, useSelector } from "react-redux";
import { setCGState } from "./customerGroupSetupSlice";

export default function Comments() {
   const dispatch = useDispatch();
   const cgState = useSelector((store) => store.customerGroupSetup);
   const { editComments } = cgState;

   function setEditComments(event) {
      const text = event.target.value;
      dispatch(setCGState("editComments", text));
   }

   return (
      <Box>
         {/* {" "}
         <Box sx={{ mt: 4, display: "flex", flexDirection: "row" }}>
            <CommentIcon sx={{ color: "blue.main" }} />
            <Typography sx={{ ml: 1, fontWeight: "bold", color: "blue.main" }}>
               Comment
            </Typography>
         </Box>{" "} */}
         {/* <Box sx={{ mt: 3, display: "flex", flexDirection: "row" }} >
				<Typography sx={{ fontWeight: "bold", color: "blue.main", width: "100%", }} 
				
				>
				<CommentIcon sx={{ color: "blue.main", mr: 1, height: "18px" }}/>
					Comments
				</Typography>
			</Box> */}
         <TextField
            className={"fullHeight"}
            value={editComments}
            onChange={setEditComments}
            overflow="scroll"
            multiline
            id="outlined-basic"
            label=""
            rows={6}
            variant="outlined"
            size="large"
            sx={{
               width: 1000,
            }}
            InputProps={{ sx: { height: sizes.w150 } }}
         />
      </Box>
   );
}
